// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__FoEgg","formSpace":"styles_formSpace__k6ETh"};